;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();import axios, { AxiosHeaders } from 'axios';
import apiBaseUrl from './apiBaseUrl';
import { i18n } from '../i18n/i18n-config';

import { auth } from './firebase';

const validLocales: readonly string[] = i18n.locales;

const axiosInstance = axios.create({ baseURL: apiBaseUrl });

axiosInstance.interceptors.request.use(
  async (axiosConfig) => {
    if (!axiosConfig.headers) axiosConfig.headers = {} as AxiosHeaders;
    if (process.env.NEXT_PUBLIC_APP) axiosConfig.headers['x-synergie-app'] = process.env.NEXT_PUBLIC_APP;

    // Saftety net: if the API is hit with an invalid locale (crawlers, garbage requests, etc.)
    // override it with the default. This prevents accumulating ZodErrors from the API.
    if (axiosConfig.params?.language && !validLocales.includes(axiosConfig.params.language))
      axiosConfig.params.language = i18n.defaultLocale;

    if (axiosConfig.data?.language && !validLocales.includes(axiosConfig.data.language))
      axiosConfig.data.language = i18n.defaultLocale;

    if (auth.currentUser) {
      const token = await auth.currentUser.getIdToken();
      if (token) axiosConfig.headers.Authorization = `Bearer ${token}`;
      else delete axiosConfig.headers.Authorization;
    } else delete axiosConfig.headers.Authorization;
    return axiosConfig;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
